export const CALL_STATUS = {
    QUEUED: "queued",
    CONNECTING: "connecting",
    RINGING: "ringing",
    IN_PROGRESS: "in-progress",
    CONNECTED: "connected",
    COMPLETED: "completed",
    BUSY: "busy",
    NO_ANSWER: "no-answer",
    FAILED: "failed",
    CANCELED: "canceled",
    REJECTED: "rejected",
    DISCONNECTED: "disconnected",
} as const;

export const CALL_TYPES = {
    INCOMING: "incoming",
    OUTGOING: "outgoing",
    MISSED: "missed",
} as const;

export const AVAILABLE_COUNTRIES: { code: string; name: string }[] = [
    { code: "AR", name: "Argentina" },
    { code: "AT", name: "Austria" },
    { code: "BE", name: "Belgium" },
    { code: "CH", name: "Switzerland" },
    { code: "DE", name: "Germany" },
    { code: "DK", name: "Denmark" },
    { code: "ES", name: "Spain" },
    { code: "FI", name: "Finland" },
    { code: "FR", name: "France" },
    { code: "GB", name: "United Kingdom" },
    { code: "GR", name: "Greece" },
    { code: "HU", name: "Hungary" },
    { code: "IE", name: "Ireland" },
    { code: "IT", name: "Italy" },
    { code: "NL", name: "Netherlands" },
    { code: "NO", name: "Norway" },
    { code: "PL", name: "Poland" },
    { code: "PT", name: "Portugal" },
    { code: "RO", name: "Romania" },
    { code: "SE", name: "Sweden" },
    { code: "SI", name: "Slovenia" },
    { code: "SK", name: "Slovakia" },
    { code: "TR", name: "Turkey" },
    { code: "UA", name: "Ukraine" },
    { code: "US", name: "United States" },
    { code: "ZA", name: "South Africa" },
].sort((a, b) => a.code.localeCompare(b.code));

export const HANGUP_COOLDOWN = 800;
